<div mat-dialog-title style="margin:0px;text-align: center; color: rgb(182, 28, 28);">FORM CHECKED OUT</div>
<mat-dialog-content>
    <div *ngIf="((!collectionCode.includes('504') && !checkOutDocument) || (collectionCode.includes('504') && !checkOutDocument504))">
        <p style="margin-top: 15px; color: black; margin-left: 10px;">
            {{templateName}} is checked out by {{checkedOutBy}}
            and not editable at this time.
        </p>
    </div>

    <div *ngIf="((!collectionCode.includes('504') && checkOutDocument == true) || (collectionCode.includes('504') && checkOutDocument504 == true))">
        <p style="margin-top: 15px; color: black; margin-left: 10px;">
            {{templateName}} is checked out by {{checkedOutBy}}
            and not editable at this time. </p>
        <p style="color: black;margin-left: 10px;">Would you like to override this?</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="sis-app-footer" style="position: sticky; padding: 0px;">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button id="saveButton" *ngIf="((!collectionCode.includes('504') && checkOutDocument) || (collectionCode.includes('504') && checkOutDocument504))" image="next arrow.png" label="Continue"
            (clickEvent)="saveClick()"></tyl-button>
        <tyl-button id="cancelButton" label="{{checkOutDocument == true ? 'Cancel': 'Close'}}" image="Cancel.png"
            (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>